// extracted by mini-css-extract-plugin
module.exports = {"annal":"Search_annal__1udvN","text":"Search_text__VtyRJ","fjdsioj2":"Search_fjdsioj2__vMnhR","content":"Search_content__1-eGx"};